const appSettings = {
  defaultLanguage: '',
  about: '',
  source: '',
  defaultCoordinate: { latitude: '', longitude: '' },
  baseUrl: 'obrasgov-map-backend/source',
  defaultZoom: 16,
  config: {},
  analyticsKey: '',
  googleApiKey: '',
  tenantClient: '',

  setSource: function(source) {
    this.source = source;
  },
  setAbout: function(_about) {
    this.about = _about;
  },
  getSource: function() {
    return this.source;
  },
  getConfig: function() {
    return this.config;
  },
  setConfig: function(_config) {
    return this.config = _config;
  },
  setDefaultCoordinate: function(coordinate) {
    this.defaultCoordinate.latitude = coordinate.latitude;
    this.defaultCoordinate.longitude = coordinate.longitude;
  },
  setDefaultLanguage: function(defaultLanguage) {
    this.defaultLanguage = defaultLanguage;
  },
  setBaseUrl: function(baseUrl) {
    this.baseUrl = baseUrl + this.baseUrl;
  },
  setDefaultZoom: function(zoom) {
    this.defaultZoom = zoom;
  },
  setAnalyticsKey: function(analyticsKey) {
    this.analyticsKey = analyticsKey;
  },
  setGoogleApiKey: function(googleApiKey) {
    this.googleApiKey = googleApiKey;
  },
  setTenantClient: function(tenantClient) {
    this.tenantClient = tenantClient;
  },
  getAbout: function() {
    return this.about;
  },
  getDefaultCoordinate: function() {
    return this.defaultCoordinate;
  },
  getDefaultLanguage: function() {
    return this.defaultLanguage;
  },
  getBaseUrl: function() {
    return this.baseUrl;
  },
  getDefaultZoom: function() {
    return this.defaultZoom;
  },
  getAnalyticsKey: function() {
    return this.analyticsKey;
  },
  getGoogleApiKey: function() {
    return this.googleApiKey;
  },
  getTenantClient: function() {
    return this.tenantClient;
  },
};

export default appSettings



// WEBPACK FOOTER //
// ./src/app/scripts/values/appSettingsValue.js